import React from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { OverlayPortal } from '../components/overlay-portal/OverlayPortal';

const ToastProvider = () => {
  return (
    <OverlayPortal><ToastContainer
      position="top-right"
      autoClose={3000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="colored"
      limit={3}
    /></OverlayPortal>
  );
};

export default ToastProvider;
